<div class="quotation-tab-content">
  <div
    class="quotation-search-container"
    *ngIf="quotations.length > 0"
  >
    <div class="search-input-wrapper">
      <i class="pi pi-search search-icon"></i>
      <input
        type="text"
        class="quotation-search-input"
        placeholder="Search by quotation no, name or mobile number..."
        [(ngModel)]="quotationSearchTerm"
        (input)="onQuotationSearch()"
        tabindex="605"
        #quotationSearchInput
      />
      <button
        *ngIf="quotationSearchTerm"
        class="clear-search-btn"
        (click)="clearQuotationSearch()"
        tabindex="606"
        type="button"
        title="Clear search"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>

  <div
    class="quotation-table-wrapper"
    *ngIf="quotations.length > 0 && filteredQuotations.length > 0"
  >
    <div class="history-table-wrapper">
      <p-table
        [value]="filteredQuotations"
        [loading]="refreshing"
        styleClass="quotation-history-table"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="col-select text-center">Select</th>
            <th class="col-quotation-number">Quotation Number</th>
            <th class="col-user-billed">Customer</th>
            <th class="col-estimated-amount text-end">Estimated Amount</th>
            <th class="col-created-date">Created Date</th>
            <th class="col-validity">Validity</th>
            <th class="col-status text-center">Status</th>
            <th class="col-action text-center">Action</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-quotation let-rowIndex="rowIndex">
          <tr
            [tabindex]="600 + rowIndex"
            [attr.data-quotation-index]="rowIndex"
            [attr.aria-label]="
              'Quotation ' +
              quotation.uuid +
              ' for ' +
              (quotation.amount | currency: 'INR')
            "
            (click)="onQuotationSelect(quotation.uuid)"
            [class.selected-row]="selectedQuotationForView === quotation.uuid"
            [class.keyboard-selected]="selectedQuotationIndex === rowIndex"
            class="quotation-row-clickable"
          >
            <td class="col-select text-center">
              <p-radioButton
                name="quotationSelection"
                [value]="quotation.uuid"
                [(ngModel)]="selectedQuotationForView"
                [inputId]="'quotation_' + rowIndex"
                (onClick)="onQuotationSelect(quotation.uuid)"
              >
              </p-radioButton>
            </td>

            <td class="col-quotation-number">
              <span class="quotation-number-text">{{
                quotation.quotationnumber || "N/A"
              }}</span>
            </td>

            <td class="col-user-billed">
              <div class="user-billed-info" [title]="quotation.name || ''">
                <div class="user-id">{{ quotation.name }}</div>
                <div class="billed-by">{{ quotation.user_id }}</div>
              </div>
            </td>

            <td class="col-estimated-amount text-end">
              <span class="tabular-num grand-total-amount">
                ₹{{ quotation.amount | number: "1.2-2" }}
              </span>
            </td>

            <td class="col-created-date">
              <div class="date-time-info">
                <div class="date">
                  {{ quotation.createdAt | date: "MMM dd, yyyy" }}
                </div>
                <div class="time">
                  {{ quotation.createdAt | date: "h:mm a" }}
                </div>
              </div>
            </td>

            <td class="col-validity">
              <div class="validity-cell">
                <span class="date">{{ quotation.validity | date: "MMM dd, yyyy" }}</span>
              </div>
            </td>

            <td class="col-status text-center">
              <span
                class="status-pill status-{{ (quotation.status || 'quotation').toLowerCase() }}"
              >
                <span class="status-dot"></span>
                <span>{{ quotation.status || 'Quotation' }}</span>
              </span>
            </td>

            <td class="col-action text-center">
              <div class="action-buttons-modern">
                <button
                  type="button"
                  class="action-btn-modern edit-btn"
                  (click)="editQuotation(quotation, $event)"
                  title="Edit Quotation"
                >
                  <i class="pi pi-pencil"></i>
                </button>
                <button
                  type="button"
                  class="action-btn-modern order-btn"
                  (click)="placeOrderFromQuotation(quotation, $event)"
                  title="Place Order"
                >
                  <i class="pi pi-shopping-cart"></i>
                </button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <!-- No quotations at all -->
  <div *ngIf="quotations.length == 0" class="history-empty">
    <ng-container *ngIf="refreshing; else noQuotations">
      <i class="pi pi-spin pi-spinner"></i>
      <p class="history-empty__title">Loading quotations…</p>
    </ng-container>
    <ng-template #noQuotations>
      <i class="pi pi-file-edit"></i>
      <p class="history-empty__title">No quotations yet</p>
      <p class="history-empty__hint">Saved quotations will appear here.</p>
    </ng-template>
  </div>

  <!-- No search results -->
  <div
    *ngIf="quotations.length > 0 && filteredQuotations.length == 0"
    class="history-empty"
  >
    <i class="pi pi-search"></i>
    <p class="history-empty__title">No results found</p>
    <p class="history-empty__hint">No quotations match your search.</p>
    <button
      type="button"
      class="premium-btn premium-btn-secondary history-empty__action"
      (click)="clearQuotationSearch()"
    >
      <i class="pi pi-times"></i> Clear search
    </button>
  </div>
</div>

<div *ngIf="showFooter" class="premium-footer">
  <button
    class="premium-btn premium-btn-secondary"
    (click)="refreshHistoryData()"
    [disabled]="refreshing"
    tabindex="503"
    type="button"
    [attr.aria-label]="'Refresh quotation list'"
  >
    <i class="pi pi-refresh"></i>
    Refresh
  </button>
  <button
    class="premium-btn premium-btn-primary"
    tabindex="504"
    [disabled]="!selectedQuotationForView"
    (click)="viewQuotation()"
    type="button"
  >
    <i class="pi pi-eye"></i>
    View Quotation
  </button>
</div>
